import React from 'react'
import { Router, Route, browserHistory, IndexRoute } from 'react-router'
import Auth from './services/auth/auth-service'

import App from './components/app'
import Login from './pages/login/container'
import Dashboard from './pages/dashboard'
import MyExperiences from './pages/my-experiences'
import FacebookDashboard from 'pages/fb-dashboard'
import ExploreExperiences from './pages/explore-experiences'
import * as Mentions from './pages/widgets/mentions'
import * as Reminder from './pages/widgets/reminder'
import * as ImageMosaic from './pages/widgets/mosaic'
import * as Competition from './pages/widgets/competition'
import * as FbCompetition from './pages/widgets/fb-competition'
import * as FbReminder from './pages/widgets/fb-reminder'
import * as FbRecurringReminder from './pages/widgets/fb-recurring-reminder'
import * as FbCoupon from './pages/widgets/fb-coupon'
import * as IgCoupon from './pages/widgets/instagram-coupon'
import * as ThreadVenture from './pages/widgets/thread_venture'
import * as TwitterSpeedThread from './pages/widgets/twitter_speed_thread'
import ViewParticipants from './pages/widgets/participants'
import Admin from './pages/admin'
import Tenants from './pages/admin/tenants'
import Users from './pages/admin/users'
import { UserPermissions, TenantPermissions } from './pages/admin/permissions'
import NotFoundPage from './pages/not-found-page'
import InstagramAuth from './pages/auth/instagram'
import ProfileSettings from './pages/profile-settings'

async function requireAuth (nextState, replace, next) {
  try {
    const isLoggedIn = await Auth.isLoggedIn()

    // istanbul ignore else
    if (!isLoggedIn) replace('/login')
    next()
  } catch (e) {
    console.error(e)
    replace('/login')
  }
}

async function requireNotAuth (nextState, replace, next) {
  try {
    const isLoggedIn = await Auth.isLoggedIn()

    // istanbul ignore next
    if (isLoggedIn) replace('/')
    next()
  } catch (e) {
    console.error(e)
    replace('/')
  }
}

export default () => (
  <Router history={browserHistory}>
    <Route path='/' component={App}>
      <IndexRoute component={Dashboard} onEnter={requireAuth} />
      <Route path='login' onEnter={requireNotAuth} component={Login} />
      <Route
        path='fb-dashboard'
        onEnter={requireAuth}
        component={FacebookDashboard}
      />
      <Route
        path='my-experiences'
        onEnter={requireAuth}
        component={MyExperiences}
      />
      <Route
        path='explore-experiences'
        onEnter={requireAuth}
        component={ExploreExperiences}
      />
      <Route
        path='experiences/create/mentions'
        onEnter={requireAuth}
        component={Mentions.Create}
      />
      <Route
        path='experiences/mention/:id/edit'
        onEnter={requireAuth}
        component={Mentions.Edit}
      />
      <Route
        path='experiences/create/twitter_threadventure'
        onEnter={requireAuth}
        component={ThreadVenture.Create}
      />
      <Route
        path='experiences/twitter_threadventure/:id/edit'
        onEnter={requireAuth}
        component={ThreadVenture.Edit}
      />
      <Route
        path='experiences/create/twitter_speed_thread'
        onEnter={requireAuth}
        component={TwitterSpeedThread.Create}
      />
      <Route
        path='experiences/twitter_speed_thread/:id/edit'
        onEnter={requireAuth}
        component={TwitterSpeedThread.Edit}
      />
      <Route
        path='experiences/create/reminder'
        onEnter={requireAuth}
        component={Reminder.Create}
      />
      <Route
        path='experiences/reminder/:id/edit'
        onEnter={requireAuth}
        component={Reminder.Edit}
      />
      <Route
        path='experiences/create/mosaic'
        onEnter={requireAuth}
        component={ImageMosaic.Create}
      />
      <Route
        path='experiences/mosaic/:id/edit'
        onEnter={requireAuth}
        component={ImageMosaic.Edit}
      />
      <Route
        path='experiences/create/competition'
        onEnter={requireAuth}
        component={Competition.Create}
      />
      <Route
        path='experiences/create/instagram_coupon'
        onEnter={requireAuth}
        component={IgCoupon.Create}
      />

      <Route
        path='experiences/create/facebook_coupon'
        onEnter={requireAuth}
        component={FbCoupon.Create}
      />
      <Route
        path='experiences/instagram_competition/:id/edit'
        onEnter={requireAuth}
        component={Competition.Edit}
      />
      <Route
        path='experiences/instagram_coupon/:id/edit'
        onEnter={requireAuth}
        component={IgCoupon.Edit}
      />
      <Route
        path='experiences/facebook_coupon/:id/edit'
        onEnter={requireAuth}
        component={FbCoupon.Edit}
      />
      <Route
        path='experiences/create/facebook-competition'
        onEnter={requireAuth}
        component={FbCompetition.Create}
      />
      <Route
        path='experiences/create/facebook-reminder'
        onEnter={requireAuth}
        component={FbReminder.Create}
      />
      <Route
        path='experiences/create/facebook-recurring-reminder'
        onEnter={requireAuth}
        component={FbRecurringReminder.Create}
      />
      <Route
        path='experiences/facebook_competition/:id/edit'
        onEnter={requireAuth}
        component={FbCompetition.Edit}
      />
      <Route
        path='experiences/facebook_reminder/:id/edit'
        onEnter={requireAuth}
        component={FbReminder.Edit}
      />
      <Route
        path='experiences/facebook_recurring_reminder/:id/edit'
        onEnter={requireAuth}
        component={FbRecurringReminder.Edit}
      />
      <Route
        path='participants/:id'
        onEnter={requireAuth}
        component={ViewParticipants}
      />
      <Route path='admin' onEnter={requireAuth} component={Admin}>
        <Route path='tenants' component={Tenants} />
        <Route path='users' component={Users} />
        <Route
          path='permissions/user'
          onEnter={requireAuth}
          component={UserPermissions}
        />
        <Route path='permissions/tenant' onEnter={requireAuth}>
          <IndexRoute component={TenantPermissions} />
          <Route path=':tenantId' component={TenantPermissions} />
        </Route>
      </Route>
      <Route
        path='settings'
        onEnter={requireAuth}
        component={ProfileSettings}
      />
      <Route
        path='auth/instagram'
        onEnter={requireAuth}
        component={InstagramAuth}
      />
      {/* Note that the 404 route should be the last route, or it will prevent those after it from rendering */}
      <Route path='*' component={NotFoundPage} />
    </Route>
  </Router>
)



// WEBPACK FOOTER //
// ./src/routes.js